"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatNodeDevices = void 0;
const api_1 = __importDefault(require("./classes/api"));
const devices_1 = __importDefault(require("./classes/devices"));
const gateway_touch_1 = __importDefault(require("./classes/gateway-touch"));
const history_1 = __importDefault(require("./classes/history"));
const images_upload_1 = __importDefault(require("./classes/images-upload"));
const lures_1 = __importDefault(require("./classes/lures"));
const maintenance_owners_1 = __importDefault(require("./classes/maintenance-owners"));
const node_consumables_1 = __importDefault(require("./classes/node-consumables"));
const node_service_issues_1 = __importDefault(require("./classes/node-service-issues"));
const node_touch_1 = __importDefault(require("./classes/node-touch"));
const properties_1 = __importDefault(require("./classes/properties"));
const pseudogateway_touch_1 = __importDefault(require("./classes/pseudogateway-touch"));
const pseudonode_touch_1 = __importDefault(require("./classes/pseudonode-touch"));
var util_1 = require("./util");
Object.defineProperty(exports, "flatNodeDevices", { enumerable: true, get: function () { return util_1.flatNodeDevices; } });
/**
 * @classdesc Represents the API-Internal SDK. Allows for calls to API-I with single function invocation
 * @class
 */
class ApiInternal {
    /**
     * Create API-Internal SDK
     * @constructor
     * @param {object} options - An object containing static options
     * @param {!string} options.baseURL - The url with the api domain
     * @param {!string} options.authenticationToken - The Api-Key authentication token
     */
    constructor(options) {
        this.options = options;
        const { baseUrl, authenticationToken } = this.options;
        // set up api
        this.api = new api_1.default(baseUrl, authenticationToken);
        // set sdk classes configuration
        this.devices = new devices_1.default(this.api);
        this.gatewayTouch = new gateway_touch_1.default(this.api);
        this.history = new history_1.default(this.api);
        this.imagesUpload = new images_upload_1.default(this.api);
        this.lures = new lures_1.default(this.api);
        this.maintenanceOwners = new maintenance_owners_1.default(this.api);
        this.nodeConsumables = new node_consumables_1.default(this.api);
        this.nodeServiceIssues = new node_service_issues_1.default(this.api);
        this.nodeTouch = new node_touch_1.default(this.api);
        this.properties = new properties_1.default(this.api);
        this.pseudogatewayTouch = new pseudogateway_touch_1.default(this.api);
        this.pseudonodeTouch = new pseudonode_touch_1.default(this.api);
    }
}
exports.default = ApiInternal;
/* eslint-disable padding-line-between-statements */
__exportStar(require("./classes/devices"), exports);
__exportStar(require("./classes/gateway-touch"), exports);
__exportStar(require("./classes/history"), exports);
__exportStar(require("./classes/images-upload"), exports);
__exportStar(require("./classes/lures"), exports);
__exportStar(require("./classes/maintenance-owners"), exports);
__exportStar(require("./classes/node-consumables"), exports);
__exportStar(require("./classes/node-service-issues"), exports);
__exportStar(require("./classes/node-touch"), exports);
__exportStar(require("./classes/properties"), exports);
__exportStar(require("./classes/pseudogateway-touch"), exports);
__exportStar(require("./classes/pseudonode-touch"), exports);
__exportStar(require("./types/common"), exports);
__exportStar(require("./types/devices"), exports);
__exportStar(require("./types/lures"), exports);
__exportStar(require("./types/maintenance-owners"), exports);
__exportStar(require("./types/node-consumables"), exports);
__exportStar(require("./types/node-service-issues"), exports);
__exportStar(require("./types/nodes"), exports);
__exportStar(require("./types/properties"), exports);
/* eslint-enable padding-line-between-statements */
//# sourceMappingURL=index.js.map